// Data + hora OPCIONAL num campo só (14/10/2026).
//
// Lucas: "mesmo colocando uma data, não aparece ali" — o próximo passo do
// negócio da CSN ("Envio da proposta no Ariba") ficou "sem data". O banco
// confirmou: `data_vencimento` vazio, nunca alterado. O campo "Prazo" era um
// <input type="datetime-local">, e o navegador só entrega o valor quando dia E
// hora estão preenchidos: escolher o dia no calendário e deixar a hora em
// "--:--" mostra a data na tela e salva VAZIO, sem aviso.
//
// Agora são dois campos: o dia (que sozinho já vale) e a hora (opcional). Sem
// hora, grava meia-noite — que o calendário de atividades já lê como "prazo do
// dia, sem hora marcada" (atividades/calendarioUtils.ts, quandoDe). O formato
// de entrada e saída é o mesmo do datetime-local ("AAAA-MM-DDTHH:mm"), para
// trocar um pelo outro sem mexer em quem converte antes de gravar.

const DIA = /^(\d{4}-\d{2}-\d{2})/;
const HORA = /T(\d{2}:\d{2})/;

/** "AAAA-MM-DDTHH:mm" → { data, hora }. Meia-noite volta como hora vazia (prazo do dia). */
export function partesDaDataHora(valor?: string | null): { data: string; hora: string } {
  const s = String(valor || '').trim();
  const d = s.match(DIA);
  if (!d) return { data: '', hora: '' };
  const h = s.match(HORA);
  const hora = h && h[1] !== '00:00' ? h[1] : '';
  return { data: d[1], hora };
}

/** { data, hora } → "AAAA-MM-DDTHH:mm" ('' sem dia). Sem hora, meia-noite: vale o dia todo. */
export function juntarDataHora(data?: string | null, hora?: string | null): string {
  const d = String(data || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) return '';
  const h = String(hora || '').trim().slice(0, 5);
  return `${d}T${/^\d{2}:\d{2}$/.test(h) ? h : '00:00'}`;
}
